import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -300px 0; }
  100% { background-position: 300px 0; }
`;

export const SlotPickerStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[8]};
  width: 100%;

  .legend {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[12]};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .legendItem {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  .dot.available {
    background: ${({ theme }) => theme.colors.accent[200]};
  }

  .dot.taken {
    background: ${({ theme }) => theme.colors.semantic.separator};
  }

  .body {
    min-height: 280px;
    max-height: 360px;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
  }

  .message {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${({ theme }) => theme.spacing[16]};
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: ${({ theme }) => theme.spacing[8]};
    align-content: start;
  }

  .slot {
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border-radius: ${({ theme }) => theme.radius[8]};
    padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[4]};
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    font-weight: ${({ theme }) => theme.typography.title.t3.weight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;
  }

  .slot.available:hover {
    background: ${({ theme }) => theme.colors.accent[50]};
    border-color: ${({ theme }) => theme.colors.semantic.outline.hover};
  }

  .slot.selected {
    border: 1.5px solid ${({ theme }) => theme.colors.semantic.text.strong};
    background: ${({ theme }) => theme.colors.semantic.container.white};
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
  }

  .slot.taken {
    color: ${({ theme }) => theme.colors.semantic.text.placeholder};
    background: ${({ theme }) => theme.colors.semantic.container.gray};
    text-decoration: line-through;
    cursor: not-allowed;
  }

  .shimmer {
    display: block;
    height: 36px;
    border-radius: ${({ theme }) => theme.radius[8]};
    background: #eef0f3
      linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0,
        rgba(255, 255, 255, 0.85) 50%,
        rgba(255, 255, 255, 0) 100%
      );
    background-size: 600px 100%;
    animation: ${shimmer} 1.2s linear infinite;
  }

  .placeholder,
  .closed,
  .error {
    padding: ${({ theme }) => theme.spacing[12]};
    border-radius: ${({ theme }) => theme.radius[8]};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    text-align: center;
    margin: 0;
  }

  .placeholder {
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    background: ${({ theme }) => theme.colors.semantic.container.gray};
  }

  .closed {
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    background: ${({ theme }) => theme.colors.semantic.container.gray};
    border: 1px dashed ${({ theme }) => theme.colors.semantic.separator};
  }

  .error {
    color: ${({ theme }) => theme.colors.semantic.text.error};
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.error};
  }
`;
